window.initBackupingReport = function() {
  backupingReport();

  function backupingReport() {
    if($('#report-form').length && !$('#report-form').hasClass('is-old-instance') && $('[data-prevent-backup]').attr('data-prevent-backup') != "true"){
      backupReport();
    }
  }

  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState != 'hidden') {
      backupingReport()
    }
  });

  window.onbeforeunload =  function() {
    setTimeout(() => {
      if(!$('#report-form').hasClass('is-old-instance')){
        backupingReport()
      }
    }, 1000);
  }

  function backupReport() {
    let changer = $('[data-changer-type]').attr('data-changer-type');
    $.ajax({
      method: "POST",
      url: `/${changer}/autosave/backup-report`,
      dataType: "script",
      data: {
        change: {
          assessment_report_id: $('[data-assessment-report-id]').attr('data-assessment-report-id'),
          last_form_instance_at: $('[data-last-form-instance-at]').attr('data-last-form-instance-at')
        }
      }
    });
  }
}
